import { render, staticRenderFns } from "./ObtainedLicenseRemiderView.vue?vue&type=template&id=76caa82c&"
import script from "./ObtainedLicenseRemiderView.vue?vue&type=script&lang=js&"
export * from "./ObtainedLicenseRemiderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports